// extracted by mini-css-extract-plugin
export default {"mediaModeToggle":"mediaModeToggle--SnbXU"};